export default __webpack_public_path__ + "./images/envelope.3b4e751c.svg";